import React from "react";
import { Link, useLocation } from "react-router-dom";
import { LayoutDashboard, PlusCircle, History, Settings } from "lucide-react";

export default function MobileNav() {
  const loc = useLocation();
  const items = [
    { to: "/dashboard", label: "Live", Icon: LayoutDashboard, testid: "mobile-nav-dashboard" },
    { to: "/add", label: "Add", Icon: PlusCircle, testid: "mobile-nav-add" },
    { to: "/history", label: "History", Icon: History, testid: "mobile-nav-history" },
    { to: "/settings", label: "Settings", Icon: Settings, testid: "mobile-nav-settings" },
  ];
  return (
    <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-[#0A0D14]/95 backdrop-blur-md border-t border-white/10">
      <div className="grid grid-cols-4">
        {items.map(({ to, label, Icon, testid }) => {
          const active = loc.pathname === to;
          return (
            <Link
              key={to}
              to={to}
              data-testid={testid}
              className={`py-3 flex flex-col items-center gap-0.5 text-[10px] uppercase tracking-widest font-semibold ${
                active ? "text-emerald-400" : "text-slate-400"
              }`}
            >
              <Icon className="h-5 w-5" />
              {label}
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
